export const createBiskoQueue = () =>
  ((window as any).biskoQueue = (window as any).biskoQueue || []);

export function bskPush(...args: any) {
  if (!(window as any)?.biskoQueue) createBiskoQueue();
  (window as any).biskoQueue.push(args);
}
